import React, { useState, useEffect } from "react"
import { USDottruck, Edit } from "../../../images"
import { Input } from "@fourkites/elemental-input"
import BottomBar from "../../BottomBar/bottombar"
import AlertIcon from "components/AlertIcon/alertIcon"
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight"
import { useHistory, useLocation } from "react-router"
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "store/store"
import { http } from "utils/http"
import { apiEndPoints } from "constants/apiEndpoints"
import "./AssetSummary.css"
import { useTranslation } from "react-i18next"
import { t } from "i18next"

const AssetSummary = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()
  const [isEnableEdit, setisEnableEdit] = useState(true)
  const [isDisableSave, setisDisableSave] = useState(false)
  const facilityId = useSelector(
    (state: RootState) => state.facilityReducer.facility?.id || ""
  )
  const assetReducer = useSelector((state: RootState) => state.assetReducer)
  const assetInfo = {
    referenceNumber: assetReducer.asset.referenceNumber,
    estimatedCheckout: assetReducer.asset.estimatedCheckout,
    HOS: assetReducer.asset.HOS,
    CompanyDetails: {
      usdot: assetReducer.asset.usdot,
      CompanyName: assetReducer.asset.companyName
    },
    AssetsDetails: {
      Tractor: assetReducer.asset.tractor,
      Trailer: assetReducer.asset.trailer
    }
  }
  const assetID = assetReducer?.asset?.id
  const [assetsdata, setassetsdata] = useState(assetInfo)
  const handlerChange = () => {
    setisEnableEdit(!isEnableEdit)
  }
  const updateDetails = (event: any) => {
    switch (event.target.name) {
      case "referenceNumber":
        assetsdata.referenceNumber = event.target.value
        break
      case "usdot":
        assetsdata.CompanyDetails.usdot = event.target.value
        break
      case "CompanyName":
        assetsdata.CompanyDetails.CompanyName = event.target.value
        break
      case "Tractor":
        assetsdata.AssetsDetails.Tractor = event.target.value
        break
      case "Trailer":
        assetsdata.AssetsDetails.Trailer = event.target.value
        break
    }
    var dynamicProperty = event.target.name
    var asset = {
      ...assetReducer.asset,
      [dynamicProperty]: event.target.value
    }
    dispatch({
      type: "SET_ASSET_INFO",
      payload: asset
    })
    setassetsdata(assetsdata)

    setisDisableSave(isInValidAssetData())
  }
  const isInValidAssetData = () => {
    let usdot = assetsdata?.CompanyDetails?.usdot
    let companyName = assetsdata?.CompanyDetails?.CompanyName
    let tractor = assetsdata?.AssetsDetails?.Tractor
    let trailer = assetsdata?.AssetsDetails?.Trailer

    return (
      usdot.trim().length == 0 ||
      companyName.trim().length == 0 ||
      tractor.trim().length == 0 ||
      trailer.trim().length == 0
    )
  }
  const submitSummary = () => {
    if (isEnableEdit) {
      if (assetID) {
        http
          .put(
            `${apiEndPoints.submitassetsinfo}/${assetID}`,
            {
              estimatedCheckout: assetsdata.estimatedCheckout,
              hos: assetsdata.HOS,
              company: {
                usdot: assetsdata?.CompanyDetails?.usdot,
                name: assetsdata?.CompanyDetails.CompanyName
              },
              asset: {
                tractor: {
                  number: assetsdata?.AssetsDetails?.Tractor
                },
                trailer: {
                  number: assetsdata?.AssetsDetails?.Trailer
                }
              }
            },
            {}
          )
          .then(res => {
            history.push("/success-asset")
          })
          .catch(err => {
            history.push("/success-asset")
          })
      } else {
        http
          .post(
            `${apiEndPoints.submitassetsinfo}`,
            {
              estimatedCheckout: assetsdata.estimatedCheckout,
              hos: assetsdata.HOS,
              facilityId: facilityId,
              referenceNumber: assetsdata?.referenceNumber,
              company: {
                usdot: assetsdata?.CompanyDetails?.usdot,
                name: assetsdata?.CompanyDetails.CompanyName
              },
              asset: {
                tractor: {
                  number: assetsdata?.AssetsDetails?.Tractor
                },
                trailer: {
                  number: assetsdata?.AssetsDetails?.Trailer
                }
              }
            },
            {}
          )
          .then(res => {
            history.push("/success-asset")
          })
          .catch(err => {
            history.push("/success-asset")
          })
      }
    } else {
      setisEnableEdit(true)
    }
  }
  const handlePaste = (event: any) => {
    switch (event.target.name) {
      case "usdot":
        assetsdata.CompanyDetails.usdot = event.target.value.substring(0, 20)
        break
      case "CompanyName":
        assetsdata.CompanyDetails.CompanyName = event.target.value.substring(
          0,
          50
        )
        break
      case "Tractor":
        assetsdata.AssetsDetails.Tractor = event.target.value.substring(0, 20)
        break
      case "Trailer":
        assetsdata.AssetsDetails.Trailer = event.target.value.substring(0, 20)
        break
    }
    var dynamicProperty = event.target.name
    var asset = {
      ...assetReducer.asset,
      [dynamicProperty]: event.target.value
    }
    dispatch({
      type: "SET_ASSET_INFO",
      payload: asset
    })
    setassetsdata(assetsdata)
  }
  useEffect(() => {
    setassetsdata(assetInfo)
  }, [])
  return (
    <>
      <div className="asset-wrapper container">
        <div className="asset-accord-container">
          <div className="assetSummary-header position-relative">
            {isEnableEdit ? t("summary") : t("edit_details")}
            <span className="accord-item-span">
              {isEnableEdit && (
                <img src={Edit} onClick={() => handlerChange()} />
              )}
            </span>
          </div>
          <div className="assetSummary-ins">
            {isEnableEdit && (
              <span>
                {t("tap_pen_icon_text")} (
                <img src={Edit} className="image-size" />){" "}
                {t("to_make_changes")}{" "}
              </span>
            )}
          </div>
        </div>
        <div className="asset-accord-container">
          <div className="asset-accord-items">
            <div className="asset-accord-item-key">{t("reference")}</div>
            <div className="accord-gate-value">
              {assetsdata?.referenceNumber}
            </div>
          </div>
        </div>
        {gateSummaryDetails({
          header: "Company Details",
          updateDetails: updateDetails,
          handlerChange: handlerChange,
          handlePaste: handlePaste,
          isEnableEdit: isEnableEdit,
          GateLinkDetails: [
            {
              key: "USDOT #",
              name: "usdot",
              value: assetsdata.CompanyDetails.usdot,
              maxLength: 20
            },
            {
              key: "Company name",
              name: "CompanyName",
              value: assetsdata.CompanyDetails.CompanyName,
              maxLength: 50
            }
          ]
        })}
        {gateSummaryDetails({
          header: "Asset Details",
          updateDetails: updateDetails,
          handlerChange: handlerChange,
          handlePaste: handlePaste,
          isEnableEdit: isEnableEdit,
          GateLinkDetails: [
            {
              key: "Tractor #",
              name: "Tractor",
              value: assetsdata.AssetsDetails.Tractor,
              maxLength: 20
            },
            {
              key: "Trailer #",
              name: "Trailer",
              value: assetsdata.AssetsDetails.Trailer,
              maxLength: 20
            }
          ]
        })}
      </div>
      <BottomBar
        disabled={isEnableEdit ? false : isDisableSave}
        text={t(isEnableEdit ? "continue" : "save")}
        onClick={() => submitSummary()}
        endIcon={<KeyboardArrowRightIcon />}
      />
    </>
  )
}
interface gateSummaryDetailProps {
  header: string
  updateDetails: (a: any) => void
  handlePaste: (a: any) => void
  handlerChange: () => void
  isEnableEdit: boolean
  GateLinkDetails: any
}

const gateSummaryDetails = (props: gateSummaryDetailProps) => {
  return (
    <>
      <div className="asset-accord-container">
        {/* <div className="accord-header-text"> {props.header} </div> */}
        {props.GateLinkDetails.map((item: any) => {
          return (
            <div className="asset-accord-items">
              <div className="asset-accord-item-key">{t(item.key)}</div>
              <div className="accord-gate-value ">
                <div>
                  <input
                    className={`${
                      !props.isEnableEdit
                        ? "asset-input-text-edit"
                        : "asset-input-text-show"
                    }`}
                    type="text"
                    name={item.name}
                    value={item.value}
                    maxLength={item.maxLength}
                    onChange={event => props.updateDetails(event)}
                    onPaste={event => props.handlePaste(event)}
                    readOnly={props.isEnableEdit}
                  />
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </>
  )
}

export default AssetSummary
